;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import styles from "./styles.module.scss"
import { Typography } from "@mui/material"
import {
  POST_HERE_SEARCH_ICON,
  POST_HERE_REFERRAL_ICON,
  POST_HERE_SEATS_ICON,
  POST_HERE_PAYMENTS_ICON,
  POST_HERE_MARKETING_ICON,
  POST_HERE_REACH_ICON,
} from "../../../shared/constants"
import searchIcon from "../../../shared/icons/search.svg"
import friendIcon from "../../../shared/icons/friend.svg"
import clipboardIcon from "../../../shared/icons/clipboard.svg"
import salaryIcon from "../../../shared/icons/salary.svg"
import ideaIcon from "../../../shared/icons/idea.svg"
import starsIcon from "../../../shared/icons/stars.svg"
import SvgIcon from "@mui/material/SvgIcon"
import Grid from "@mui/material/Grid" // Grid version 2
const ICON_CONTAINER_UI = "absolute"
function IconAndReason({ iconType, title, description }) {
  const renderIcon = () => {
    switch (iconType) {
      case POST_HERE_SEARCH_ICON:
        return (
          <div className={`${ICON_CONTAINER_UI} ${styles["search-icon-container"]}`}>
            <SvgIcon
              component={searchIcon}
              viewBox="0 0 90 90"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "70px",
                  height: "70px",
                },
                width: "63px",
                height: "63px",
              }}
            />
          </div>
        )

      case POST_HERE_REFERRAL_ICON:
        return (
          <div className={`${ICON_CONTAINER_UI} ${styles["friend-icon-container"]}`}>
            <SvgIcon
              component={friendIcon}
              viewBox="0 0 1200 1200"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "154px",
                  height: "120px",
                },
                width: "116px",
                height: "106px",
              }}
            />
          </div>
        )
      case POST_HERE_SEATS_ICON:
        return (
          <div
            className={`${ICON_CONTAINER_UI} ${styles["clipboard-icon-container"]}`}
          >
            <SvgIcon
              component={clipboardIcon}
              viewBox="0 0 1200 1200"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "105px",
                  height: "105px",
                },
                width: "96px",
                height: "96px",
              }}
            />
          </div>
        )
      case POST_HERE_PAYMENTS_ICON:
        return (
          <div className={`${ICON_CONTAINER_UI} ${styles["salary-icon-container"]}`}>
            <SvgIcon
              component={salaryIcon}
              viewBox="0 0 1200 1200"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "149px",
                  height: "115px",
                },
                width: "102px",
                height: "88px",
              }}
            />
          </div>
        )
      case POST_HERE_MARKETING_ICON:
        return (
          <div className={`${ICON_CONTAINER_UI} ${styles["idea-icon-container"]}`}>
            <SvgIcon
              component={ideaIcon}
              viewBox="0 0 1200 1200"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "108px",
                  height: "144px",
                },
                width: "99px",
                height: "133px",
              }}
            />
          </div>
        )
      case POST_HERE_REACH_ICON:
        return (
          <div className={`${ICON_CONTAINER_UI} ${styles["stars-icon-container"]}`}>
            <SvgIcon
              component={starsIcon}
              viewBox="0 0 1200 1200"
              sx={{
                "@media only screen and (min-width: 600px)": {
                  width: "108px",
                  height: "132px",
                },
                width: "100px",
                height: "127px",
              }}
            />
          </div>
        )
    }
  }
  const renderHeader = () => {
    return <div className={styles["header"]}>{title}</div>
  }
  const renderBody = () => {
    return <div className={styles["body"]}>{description}</div>
  }
  return (
    <Grid
      sx={{ display: "flex", justifyContent: "center" }}
      size={{
        xs: 12,
        sm: 5,
        md: 4,
        // lg: 4,
      }}
    >
      <div
        className={
          "relative flex flex-row pl-[60px] min-[600px]:flex-col min-[600px]:pl-0 min-[600px]:pt-[60px]"
        }
      >
        {renderIcon()}
        <div className={"flex flex-col"}>
          {renderHeader()}
          {renderBody()}
        </div>
      </div>
    </Grid>
  )
}

export default IconAndReason
